import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import ReactECharts from 'echarts-for-react';
import excelExportIcon from '../../../images/excelExport.png';
import { AiOutlineFileExcel } from 'react-icons/ai';

import {
	requestDoencasAgravosOptions,
	requestDoencasAgravos,
	requestDoencasAgravosGrafico,
	requestDoencasAgravosExcel,
	requestDoencasAgravosGraficoExcel,
} from '../../../services/requests';

// Mock de doenças com seus dados
const MOCK_DOENCAS = {
	Dengue: {
		nome: 'Dengue',
		descricao:
			'Doença viral transmitida pelo mosquito Aedes aegypti, caracterizada por febre alta, dores no corpo e manchas na pele.',
	},
	Chikungunya: {
		nome: 'Chikungunya',
		descricao:
			'Infecção viral transmitida por mosquitos que causa febre e dores articulares intensas, podendo tornar-se crônica.',
	},
	Zika: {
		nome: 'Zika',
		descricao:
			'Doença causada pelo vírus Zika, transmitida pelo Aedes aegypti, pode causar microcefalia em bebês de mães infectadas.',
	},
	'COVID-19': {
		nome: 'COVID-19',
		descricao:
			'Doença infecciosa causada pelo coronavírus SARS-CoV-2, afeta principalmente o sistema respiratório.',
	},
	Tuberculose: {
		nome: 'Tuberculose',
		descricao:
			'Doença infectocontagiosa causada pela bactéria Mycobacterium tuberculosis, afeta principalmente os pulmões.',
	},
};

const MOCK_OPTIONS = {
	sexo: ['Masculino', 'Feminino', 'Não Informado'],
	raca: ['Branca', 'Preta', 'Parda', 'Amarela', 'Indígena', 'Não Informado'],
	faixaEtaria: [
		'0-4 anos',
		'5-9 anos',
		'10-14 anos',
		'15-19 anos',
		'20-29 anos',
		'30-39 anos',
		'40-49 anos',
		'50-59 anos',
		'60+ anos',
	],
	bairro: [
		'Centro',
		'Copacabana',
		'Ipanema',
		'Leblon',
		'Botafogo',
		'Flamengo',
		'Tijuca',
		'Vila Isabel',
		'Méier',
		'Barra da Tijuca',
	],
	classificacaoRisco: [
		'Baixo Risco',
		'Médio Risco',
		'Alto Risco',
		'Muito Alto Risco',
	],
	apPaciente: [
		'A.P. 1.0',
		'A.P. 2.1',
		'A.P. 2.2',
		'A.P. 3.1',
		'A.P. 3.2',
		'A.P. 3.3',
		'A.P. 4.0',
		'A.P. 5.1',
		'A.P. 5.2',
		'A.P. 5.3',
	],
	unidade: [
		'UPA Centro',
		'UPA Copacabana',
		'UPA Tijuca',
		'Hospital Municipal',
		'Clínica da Família Norte',
		'Clínica da Família Sul',
	],
	ap: ['A.P. 1.0', 'A.P. 2.1', 'A.P. 2.2', 'A.P. 3.1', 'A.P. 3.2'],
	superintendencia: [
		'Superintendência Centro',
		'Superintendência Norte',
		'Superintendência Sul',
		'Superintendência Oeste',
	],
	cid: [
		'A90 - Dengue',
		'A92.0 - Chikungunya',
		'A92.5 - Zika',
		'U07.1 - COVID-19',
		'A15 - Tuberculose',
	],
};

function DoencasAgravos() {
	// Estado principal com todos os filtros
	const [filtros, setFiltros] = useState({
		doencaAgravo: '',
		sexo: '',
		raca: '',
		faixaEtaria: '',
		bairro: '',
		classificacaoRisco: '',
		apPaciente: '',
		unidade: '',
		ap: '',
		superintendencia: '',
		cid: '',
		dataInicio: '',
		dataFim: '',
		exibirPor: 'dia',
	});

	const [doencaSelecionada, setDoencaSelecionada] = useState(null);
	const [loading, setLoading] = useState(false);
	const [exportingSerie, setExportingSerie] = useState(false);

	// Atualiza a doença selecionada quando o filtro muda
	useEffect(() => {
		if (filtros.doencaAgravo && MOCK_DOENCAS[filtros.doencaAgravo]) {
			setDoencaSelecionada(MOCK_DOENCAS[filtros.doencaAgravo]);
		} else {
			setDoencaSelecionada(null);
		}
	}, [filtros.doencaAgravo]);

	// Função para atualizar um filtro específico
	const handleFiltroChange = (campo, valor) => {
		setFiltros((prev) => ({
			...prev,
			[campo]: valor,
		}));
	};

	// Função para aplicar filtros
	const handleApplyFilters = () => {
		setLoading(true);
		// Aqui você chamaria suas APIs reais com os filtros
		console.log('Aplicando filtros:', filtros);
		setTimeout(() => setLoading(false), 1000);
	};

	// Função para limpar filtros
	const handleClearFilters = () => {
		setFiltros({
			...filtros,
			sexo: '',
			raca: '',
			faixaEtaria: '',
			bairro: '',
			classificacaoRisco: '',
			apPaciente: '',
			unidade: '',
			ap: '',
			superintendencia: '',
			cid: '',
			dataInicio: '',
			dataFim: '',
			exibirPor: 'dia',
		});
	};

	// Função para exportar série histórica
	const handleExportSerieHistorica = async () => {
		setExportingSerie(true);
		// Aqui você chamaria sua API real
		console.log('Exportando série histórica com filtros:', filtros);
		setTimeout(() => setExportingSerie(false), 2000);
	};

	// Mock de dados para o gráfico
	const getChartOption = () => {
		const periodos = [
			'Jan',
			'Fev',
			'Mar',
			'Abr',
			'Mai',
			'Jun',
			'Jul',
			'Ago',
			'Set',
			'Out',
			'Nov',
			'Dez',
		];
		const casos = [
			120, 150, 180, 220, 190, 160, 140, 170, 200, 230, 210, 190,
		];

		return {
			title: {
				text: 'Série Histórica - Doenças e Agravos',
				left: 'center',
				textStyle: {
					fontSize: 16,
					fontWeight: 'normal',
					color: '#004A80',
				},
			},
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'cross',
					label: {
						backgroundColor: '#6a7985',
					},
				},
				formatter: function (params) {
					let result = `<strong>${params[0].axisValue}</strong><br/>`;
					params.forEach((item) => {
						result += `${item.marker} ${item.seriesName}: <strong>${item.value}</strong><br/>`;
					});
					return result;
				},
			},
			legend: {
				data: ['Total de Casos'],
				top: 35,
			},
			toolbox: {
				feature: {
					saveAsImage: {
						title: 'Salvar como imagem',
					},
				},
				right: 20,
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '10%',
				containLabel: true,
			},
			xAxis: [
				{
					type: 'category',
					boundaryGap: false,
					data: periodos,
					axisLabel: {
						rotate: 0,
						interval: 0,
						fontSize: 11,
					},
				},
			],
			yAxis: [
				{
					type: 'value',
					name: 'Casos',
				},
			],
			series: [
				{
					name: 'Total de Casos',
					type: 'line',
					stack: 'Total',
					areaStyle: {},
					lineStyle: {
						color: '#3b82f6',
						width: 2,
					},
					itemStyle: {
						color: '#3b82f6',
					},
					emphasis: {
						focus: 'series',
					},
					data: casos,
				},
			],
		};
	};

	return (
		<div className='space-y-[18px]'>
			{/* Subtitle */}
			<div>
				<div className='w-full h-full align-middle items-center text-[#13335A] font-semibold text-[32px] sm:p-0 landing-0'>
					Doenças e agravos
				</div>
				<p className='text-gray-600 text-[14px]'>
					Monitoramento de doenças e agravos notificados na rede
				</p>
			</div>

			<div className='flex-1 min-w-[150px]'>
				<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
					Doença/agravo
				</label>
				<select
					value={filtros.doencaAgravo}
					onChange={(e) =>
						handleFiltroChange('doencaAgravo', e.target.value)
					}
					className='w-full px-2 py-3 border border-[#E3E3E3] rounded-md shadow-sm ${} focus:outline-none text-[#4F5257] text-sm'>
					<option
						value=''
						disabled
						hidden>
						Nome da Doença/agravo
					</option>
					{Object.keys(MOCK_DOENCAS).map((doenca, index) => (
						<option
							key={index}
							value={doenca}>
							{doenca}
						</option>
					))}
				</select>
			</div>
			<hr></hr>

			{/* Só mostra os filtros e gráficos se uma doença foi selecionada */}
			{doencaSelecionada && (
				<>
					{/* Filters - Primeira Linha */}
					<div className='p-[12px] border rounded-md flex gap-1 flex-col'>
						<p className='text-[#4F5257] font-semibold text-[16px]'>
							{doencaSelecionada.nome}
						</p>
						<p className='text-[#4F5257] text-[14px]'>
							{doencaSelecionada.descricao}
						</p>
						<hr className='my-2'></hr>

						<div className='flex flex-wrap gap-[12px] bg-[#FCFCFC] items-end p-[8px] border rounded-md'>
							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Sexo
								</label>
								<select
									value={filtros.sexo}
									onChange={(e) =>
										handleFiltroChange(
											'sexo',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.sexo === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.sexo.map((sexo, index) => (
										<option
											key={index}
											value={sexo}
											className='text-[#4F5257]'>
											{sexo}
										</option>
									))}
								</select>
							</div>
							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Raça
								</label>
								<select
									value={filtros.raca}
									onChange={(e) =>
										handleFiltroChange(
											'raca',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.raca === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.raca.map((raca, index) => (
										<option
											key={index}
											value={raca}
											className='text-[#4F5257]'>
											{raca}
										</option>
									))}
								</select>
							</div>

							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Faixa etária
								</label>
								<select
									value={filtros.faixaEtaria}
									onChange={(e) =>
										handleFiltroChange(
											'faixaEtaria',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.faixaEtaria === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.faixaEtaria.map(
										(faixa, index) => (
											<option
												key={index}
												value={faixa}
												className='text-[#4F5257]'>
												{faixa}
											</option>
										)
									)}
								</select>
							</div>

							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Bairro
								</label>
								<select
									value={filtros.bairro}
									onChange={(e) =>
										handleFiltroChange(
											'bairro',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.bairro === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.bairro.map(
										(bairro, index) => (
											<option
												key={index}
												value={bairro}
												className='text-[#4F5257]'>
												{bairro}
											</option>
										)
									)}
								</select>
							</div>
							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Classificação de Risco
								</label>
								<select
									value={filtros.classificacaoRisco}
									onChange={(e) =>
										handleFiltroChange(
											'classificacaoRisco',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.classificacaoRisco === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.classificacaoRisco.map(
										(classificacao, index) => (
											<option
												key={index}
												value={classificacao}
												className='text-[#4F5257]'>
												{classificacao}
											</option>
										)
									)}
								</select>
							</div>
							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									A.P. do Paciente
								</label>
								<select
									value={filtros.apPaciente}
									onChange={(e) =>
										handleFiltroChange(
											'apPaciente',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.apPaciente === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.apPaciente.map(
										(ap, index) => (
											<option
												key={index}
												value={ap}
												className='text-[#4F5257]'>
												{ap}
											</option>
										)
									)}
								</select>
							</div>
						</div>

						{/* Filters - Segunda Linha */}
						<div className='flex flex-wrap gap-[12px] items-end'>
							<div className='flex-1 w-full min-w-[363px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Unidade
								</label>
								<select
									value={filtros.unidade}
									onChange={(e) =>
										handleFiltroChange(
											'unidade',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.unidade === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.unidade.map(
										(unidade, index) => (
											<option
												key={index}
												value={unidade}
												className='text-[#4F5257]'>
												{unidade}
											</option>
										)
									)}
								</select>
							</div>
							<div className='flex-1 w-full sm:w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									A.P.
								</label>
								<select
									value={filtros.ap}
									onChange={(e) =>
										handleFiltroChange('ap', e.target.value)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.ap === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.ap.map((ap, index) => (
										<option
											key={index}
											value={ap}
											className='text-[#4F5257]'>
											{ap}
										</option>
									))}
								</select>
							</div>

							<div className='flex-1 w-full min-w-[363px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Superintendência
								</label>
								<select
									value={filtros.superintendencia}
									onChange={(e) =>
										handleFiltroChange(
											'superintendencia',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.superintendencia === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.superintendencia.map(
										(sup, index) => (
											<option
												key={index}
												value={sup}
												className='text-[#4F5257]'>
												{sup}
											</option>
										)
									)}
								</select>
							</div>
							<div className='flex-1 w-full min-w-[200px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									CID
								</label>
								<select
									value={filtros.cid}
									onChange={(e) =>
										handleFiltroChange(
											'cid',
											e.target.value
										)
									}
									className={`w-full px-2 py-[10px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none text-sm ${
										filtros.cid === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}>
									<option
										value=''
										className='text-[#E3E3E3]'>
										Selecione
									</option>
									{MOCK_OPTIONS.cid.map((cid, index) => (
										<option
											key={index}
											value={cid}
											className='text-[#4F5257]'>
											{cid}
										</option>
									))}
								</select>
							</div>

							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Data Início
								</label>
								<input
									type='date'
									value={filtros.dataInicio}
									onChange={(e) =>
										handleFiltroChange(
											'dataInicio',
											e.target.value
										)
									}
									className={`w-full px-2 py-[8px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none  text-sm ${
										filtros.dataInicio === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}></input>
							</div>
							<div className='flex-1 min-w-[150px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Data fim
								</label>
								<input
									type='date'
									value={filtros.dataFim}
									onChange={(e) =>
										handleFiltroChange(
											'dataFim',
											e.target.value
										)
									}
									className={`w-full px-2 py-[8px] border border-[#E3E3E3] rounded-md shadow-sm focus:outline-none  text-sm ${
										filtros.dataFim === ''
											? 'text-[#E3E3E3]'
											: 'text-[#4F5257]'
									}`}></input>
							</div>

							<div className='flex-1 max-w-[122px]'>
								<label className='block text-[16px] font-inter text-[#4F5257] mb-2'>
									Exibir por
								</label>
								<div className='px-1  py-[8px] border rounded-md flex items-center content-center text-[#4F5257] text-[14px] shadow-sm  justify-around'>
									<div className='flex items-center gap-1'>
										<input
											type='radio'
											name='exibir'
											value='dia'
											checked={
												filtros.exibirPor === 'dia'
											}
											onChange={(e) =>
												handleFiltroChange(
													'exibirPor',
													e.target.value
												)
											}></input>
										Dia
									</div>
									<div className='flex items-center gap-1'>
										<input
											type='radio'
											name='exibir'
											value='mes'
											checked={
												filtros.exibirPor === 'mes'
											}
											onChange={(e) =>
												handleFiltroChange(
													'exibirPor',
													e.target.value
												)
											}></input>
										Mês
									</div>
								</div>
							</div>

							<div className='flex gap-2'>
								<button
									onClick={handleApplyFilters}
									disabled={loading}
									className='px-[22px] py-[10px] bg-[#13335A] text-[#FFFFFF] rounded-md hover:bg-[#0f2c4e] transition-colors text-sm font-normal disabled:opacity-50 disabled:cursor-not-allowed'>
									{loading
										? 'Carregando...'
										: 'Aplicar Filtros'}
								</button>
								<button
									onClick={handleClearFilters}
									disabled={loading}
									className='px-6 py-2 border border-[#E3E3E3] text-[#757575] rounded-md hover:bg-gray-50 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed shadow-sm '>
									Limpar
								</button>
							</div>
						</div>
					</div>

					{/* Update timestamp */}
					<div className='text-right'>
						<p className='text-xs text-gray-500'>
							Última atualização:{' '}
							{new Date().toLocaleString('pt-BR')}
						</p>
					</div>

					{/* GRÁFICOS */}
					{/* Renderização dinâmica dos gráficos */}
					{Array.from({ length: 3 })
						.map((_, i) => i)
						.reduce((linhas, item, index, arr) => {
							if (index % 2 === 0) {
								if (
									index === arr.length - 1 &&
									arr.length % 2 !== 0
								) {
									linhas.push([item]);
								} else {
									linhas.push([item, arr[index + 1]]);
								}
							}
							return linhas;
						}, [])
						.map((linha, indexLinha) => (
							<div
								key={indexLinha}
								className='flex flex-col md:flex-row justify-center gap-[18px] mb-6 w-full'>
								{linha.map((grafico, idx) => (
									<div
										key={idx}
										className={`bg-white w-full p-[8px] rounded-lg shadow-sm border border-gray-200`}>
										{/* Cabeçalho */}
										<div className='mb-[6px]'>
											<div className='flex justify-between items-center'>
												<h3 className='text-[20px] font-medium text-[#4F5257]'>
													Título do gráfico{' '}
													{grafico + 1}
												</h3>

												<button
													onClick={
														handleExportSerieHistorica
													}
													disabled={exportingSerie}
													className='p-[12px] border border-[#E3E3E3] rounded-md text-sm text-[#757575] hover:text-white hover:bg-[#195a36] hover:border-[#195a36] transition-all duration-300 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm'>
													{exportingSerie ? (
														<>⏳ Exportando...</>
													) : (
														<>
															<AiOutlineFileExcel className='w-[20px] h-auto' />
															Exportar em Excel
														</>
													)}
												</button>
											</div>
										</div>

										{/* Gráfico */}
										<div className='bg-white rounded-lg h-[450px] border border-gray-200'>
											{loading ? (
												<div className='flex items-center justify-center h-full'>
													<p className='text-gray-400 text-sm'>
														Carregando gráfico...
													</p>
												</div>
											) : (
												<ReactECharts
													option={getChartOption()}
													style={{
														height: '100%',
														width: '100%',
													}}
													opts={{
														renderer: 'canvas',
													}}
												/>
											)}
										</div>

										<p className='text-[12px] italic text-gray-500 mt-1'>
											Fonte
										</p>
										<p className='text-[12px] text-gray-500 mt-1'>
											Texto auxiliar
										</p>
									</div>
								))}
							</div>
						))}
				</>
			)}
		</div>
	);
}

export default DoencasAgravos;
